import React, { Component } from 'react';
import Nav from './Nav';
import './App.css';


class App extends React.Component{

  render() {
    return (
      <div>
        <h1 className='text-center title'> <span>MARVEL</span> GALERY</h1>
        <Nav page={0} />
      </div>
    )
  }
}

export default App;
